/// <amd-module name="Wit/Common/BacklogContentService/BacklogContentContants" />

export namespace BacklogColumnSettings {
    export const ColumnsOptions = "Agile/BacklogsHub/ColumnOptions";
    export const ColumnsOptionsKey = "Agile/BacklogsHub/ColumnOptions/{0}";
    export const BacklogItems = "Backlog items";
    export const Issues = "Issues";
    export const IssuesKey = "ProductBacklogColumnOptions";
    export const Level = "Agile/BacklogsHub/Level";
    export const LevelKey = "Agile/BacklogsHub/Level/{0}";
    export const Requirements = "Microsoft.RequirementCategory";
    export const Tasks = "Microsoft.TaskCategory";
    export const TeamScope = "WebTeam";
    export const BacklogId = "BacklogId";
    export const BacklogsHubKey = "Agile/BacklogsHub";
}

export namespace SprintsBacklogColumnSettings {
    export const ColumnOptions = "Agile/SprintsHub";
    export const ColumnOptionsKey = "Agile/SprintsHub/{0}";
    export const IterationKey = "IterationBacklogColumnOptions";
}

export const SprintsFilterKey = "Sprints/backlogs/Filter";

export enum AddWorkItemLocations {
    Top = "top",
    Bottom = "bottom",
    Selection = "selection"
}

export namespace CommonBacklogDataProviders {
    export const CurrentTeam = "ms.vss-tfs-web.team-context-data-provider";
    export const PageWorkItemsDataProvider = "ms.vss-work-web.page-work-items-data-provider";
}

export type TopBottomSelection = "top" | "bottom" | "selection";
